import { InvariantError } from '#src/invariant/invariant_error.ts';

/**
 * Throws an InvariantError if the condition is falsey value.
 * The invariant error will have the message provided.
 *
 * Inspired by: https://github.com/zertosh/invariant/blob/master/invariant.js
 * Consider if this should be replaced by Preconditions from Google.
 */
export function invariant(condition: any, message: string): asserts condition {
  if (!condition) {
    throw new InvariantError(message);
  }
}
